import api from "../instance/axios_instance.ts";
import { OfficeInterface } from "../interface/officeInterface";

const OfficeApi = async (): Promise<OfficeInterface> => {

    try {
        const response = await api.get<OfficeInterface>('/office');
        return response.data;
    } catch (error) {
        const mensajeError = error.response?.data?.message;
        throw new Error(mensajeError || 'Error credito');
    }

};

export default OfficeApi;